import { useContext } from 'react';
import { store } from 'components/Store';

const parliamentarianUsers = (code) => {
  if (code) {
    return code.startsWith('MogulFree');
  }
};

const consultantAgenciesMembers = (code) => {
  if (code) {
    return code.startsWith('Agency');
  }
};

const membershipMembers = (code) => {
  if (code) {
    return code.startsWith('MembershipOrganisation');
  }
};

/** Comma-separated emails in VITE_APP_DATAHUB_USERS (trimmed, case-insensitive match). */
const parseDataHubUserEmailsFromEnv = () => {
  const raw = import.meta.env.VITE_APP_DATAHUB_USERS;
  if (!raw || typeof raw !== 'string') return [];
  return raw
    .split(',')
    .map((part) => part.trim().toLowerCase())
    .filter(Boolean);
};

/** Parsed once at load; `import.meta.env` is static for a given build. */
const DATA_HUB_USER_EMAILS = parseDataHubUserEmailsFromEnv();

const dataHubUsers = (email) => {
  if (!email || typeof email !== 'string') return false;
  if (DATA_HUB_USER_EMAILS.length === 0) return false;
  const normalizedEmail = email.trim().toLowerCase();
  if (!normalizedEmail) return false;
  return DATA_HUB_USER_EMAILS.includes(normalizedEmail);
};

const viewCode = ({ code, location }) => {
  const start =
    location?.search === '' || (location?.search.match(/=/g)?.length === 1 && location?.search?.includes('view='))
      ? '?'
      : '&';
  if (parliamentarianUsers(code)) {
    return `${start}view=p`;
  } else if (code && consultantAgenciesMembers(code)) {
    return `${start}view=c`;
  } else if (membershipMembers(code)) {
    return `${start}view=m`;
  } else {
    return '';
  }
};

const useTypeOfUsers = () => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { activePlan } = state;
  const { code } = activePlan;
  const isParliamentarian = parliamentarianUsers(code);
  return { isParliamentarian };
};

const campaignersUsers = ({ name }) => {
  return name === 'Campaigner';
};

export { consultantAgenciesMembers, viewCode, membershipMembers, useTypeOfUsers, campaignersUsers, dataHubUsers };
export default parliamentarianUsers;
